import type { App, Plugin } from "vue";

import {
  ICheckbox,
  IDatePicker,
  IDescriptionItem,
  IDescriptions,
  IDialog,
  IDivider,
  IDrawer,
  IForm,
  IGeoMark,
  IIconSelect,
  IImageVerification,
  ILink,
  ILivePlayer,
  IMap,
  IMonitorPlayback,
  IPageHeader,
  IRadio,
  ISearch,
  ISegmented,
  ISelect,
  ISplitPane,
  ITable,
  ITenantEnterprise,
  ITextButton,
  ITextButtonGroup,
  ITzjPlayer,
} from "./components";

const component = [
  IForm,
  ISelect,
  IRadio,
  ICheckbox,
  IDivider,
  IDrawer,
  IIconSelect,
  IImageVerification,
  ITextButton,
  ITextButtonGroup,
  IPageHeader,
  ISearch,
  ITable,
  ISplitPane,
  ITenantEnterprise,
  ISegmented,
  IDescriptions,
  IDescriptionItem,
  ILivePlayer,
  IDialog,
  ILink,
  IMonitorPlayback,
  ITzjPlayer,
  IDatePicker,
  IMap,
  IGeoMark,
] as Plugin[];

export const install = function (app: App, _options?: any) {
  component.forEach((i) => app.use(i, _options));
};

export default {
  install,
};
